module.exports = __webpack_public_path__ + "static/assets/9c047823333671f288e92ea69c6ae417.png";